import { IFrequency, WorkflowTaskConfiguration } from '../models';

export const Steps = [
    {
        label: 'Cleaning input values',
        propertyName: 'hasCleaningInputData'
    },
    {
        label: 'Cleaning results',
        propertyName: 'hasCleaningWideResults'
    },
    {
        label: 'Acquisition',
        propertyName: 'hasAcquisition'
    },
    {
        label: 'Script computation',
        propertyName: 'hasScriptComputation'
    },
    {
        label: 'States computation',
        propertyName: 'hasComputation'
    },
    {
        label: 'Reconciliation',
        propertyName: 'hasReconciliation'
    },
    {
        label: 'Calc. values statuses',
        propertyName: 'hasCalculatedValuesStatuses'
    },
    {
        label: 'Historian storage',
        propertyName: 'hasHistorianStorage'
    }
];

export const Configurations = [
    {
        label: 'Include precedent groups',
        propertyName: 'includeDependencies'
    }, {
        label: 'Include dependent groups',
        propertyName: 'includeDependent'
    }, {
        label: 'Include children',
        propertyName: 'includeChildren'
    }, {
        label: 'Only failed and missing',
        propertyName: 'onlyFailed'
    }, {
        label: 'Only completed periods',
        propertyName: 'onlyCompleted'
    }
];

export function createConfiguration(
    interval: { beginDate: string, endDate: string },
    groupGuidList: string[],
    steps: { value: boolean }[],
    batchFrequency?: IFrequency
): WorkflowTaskConfiguration {

    const configuration = {
        beginDateTime: interval.beginDate,
        endDateTime: interval.endDate,
        groupGuidList: groupGuidList,
        batchFrequency: batchFrequency
    } as WorkflowTaskConfiguration;

    Steps.concat(Configurations).forEach((s, i) => {
        configuration[s.propertyName] = steps[i] ? steps[i].value : true;
    });

    return configuration;
}